module.exports = __webpack_public_path__ + "static/d-aa00b033b2c424a5c388b1faffd9cd08.png";